import styled from '@emotion/styled';
import DialogContent from '@mostrans/web-components/components/base/Dialog/DialogContent';
import { Avatar, Icon, Tooltip } from '@mui/material';
import React from 'react';
import ReactQuill from 'react-quill';
import { toast } from 'react-toastify';
import { IconButton } from 'rsuite';
import { headerImage, logoTwitter } from '../../assets';
import Badge from '../General/Badge';

const ModalHeaderContainer = styled.div`
    display: flex;
    align-items: center;
    background-image: url(${props => props.imageUrl});
    background-size: cover;
    background-position: center;
    height: 150px;
    width: 100%;
`;

// @media (max-width: 768px) {
//     height: 100px;
//     }
//     @media (max-width: 480px) {
//     height: 80px;
//     }




function ModalContentDetailOpportunity({ detailOpportunity }) {
    const currentURL = window.location.href;

    const copyURL = async () => {
        const currentURL = window.location.href;
        try {
            await navigator.clipboard.writeText(currentURL);
            toast.success('Link copied to clipboard!');
        } catch (err) {
            console.error('Failed to copy: ', err);
            toast.error('Failed to copy link to clipboard. Please try again.');
        }
    };



    const handleShareTwitter = () => {
        const title = "Hey, check this job vacancy, and let's find the opportunity to #LifetAtMostrans | Mostrans Careers";
        const tweetText = encodeURIComponent(title);
        const tweetUrl = encodeURIComponent(currentURL);

        const twitterShareUrl = `https://twitter.com/intent/tweet?text=${tweetText}&url=${tweetUrl}`;
        window.open(twitterShareUrl, '_blank');
    };



    return (
        <React.Fragment>
            <ModalHeaderContainer imageUrl={headerImage}>
                <div className='d-flex flex-grow-1 justify-content-between p-2 mt-2'>
                    <div className='d-flex'>
                        <h3>{detailOpportunity?.title}</h3>
                    </div>
                    <div className='d-flex flex-column'>
                        <div className='mb-1'>
                            <Badge><b>{detailOpportunity?.Division?.division}</b></Badge>
                        </div>
                    </div>
                </div>

            </ModalHeaderContainer>
            <DialogContent>
                <div className='d-flex flex-column p-2'>
                    <div className='d-flex justify-content-between'>
                        <div className='d-flex gap-2'>
                            <b className='text-secondary'>{detailOpportunity?.job_level}</b>
                            <div className='d-flex'>
                                <Icon className='text-secondary'>location_on</Icon>
                                <b className='text-secondary'>
                                    {detailOpportunity?.Location?.nama}
                                </b>
                            </div>
                        </div>
                        <div className='d-flex'>
                            <div className='d-flex flex-column'>
                                <b>Share This Job</b>
                                <div className='d-flex gap-1'>
                                    <Tooltip title='Copy Link'>
                                        <IconButton onClick={copyURL}>
                                            <Icon>link</Icon>
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title='Share on twitter post'>
                                        <IconButton onClick={handleShareTwitter}>
                                            <Avatar
                                                sx={{ width: 30, height: 30 }}
                                                variant="rounded"
                                                src={logoTwitter}
                                            />
                                        </IconButton>
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='d-flex flex-column mt-2'>
                        <h5 className='text-primary-main'>Description</h5>
                        <ReactQuill
                            value={detailOpportunity?.description}
                            readOnly
                            theme="bubble"
                        />
                    </div>
                    <div className='d-flex flex-column mt-2'>
                        <h5>Requirement</h5>
                        <ul>
                            {detailOpportunity?.Requirement
                                ? detailOpportunity?.Requirement?.map((result) => (
                                    <li
                                        key={result?.id}
                                        style={{ listStyleType: "disc", margin: "0 15px", fontSize: "13px" }}>
                                        {result?.job_requirement}
                                    </li>
                                ))
                                : "No Job Requirement"}
                        </ul>
                    </div>
                </div>
            </DialogContent>
        </React.Fragment>
    )
}

export default ModalContentDetailOpportunity